import { useEffect, useState } from "react"
import Companies from "./Companies"
import IPWhitelist from "./IPWhitelist"
import IPBannedList from "./IPBannedList"

type AdminProps = {
    subpage?: string
}

const Admin: React.FC<AdminProps> = ({ subpage }) => {
    const [currentPage, setCurrentPage] = useState(subpage || "companies")
    
    useEffect(() => {
        if (subpage) {
            setCurrentPage(subpage)
        }
    }, [subpage])
    
    switch (currentPage) {
        case "companies":
            return <Companies />
        case "ip-whitelist":
            return <IPWhitelist />
        case "ip-banned":
            return <IPBannedList />
        default:
            return <Companies />
    }
}

export default Admin